import React, { useState } from 'react'
import { Drawer } from 'antd'
import { useHistory, useParams } from 'react-router-dom'

import { useToggle, usePet } from '../../modules'

const Notes = ({ onClose, item }) => {
    const [entry, setEntry] = useState()
    const [notes, setNotes] = useState([])

    const history = useHistory()
    const { id, entry: eid } = useParams()

    const [visible, toggleVisible] = useToggle(true)

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    const [{ loading, error }] = usePet('singleEntry', { id: eid }, { notify: false, callback: ({ data }) => {
        setEntry(data)
        let nts = data.fields.map(fld => ({
            ...fld,
            name: fld.name,
            type: fld.type,
            value: fld.value[0]
        }))
        setNotes(nts)
    }, manual: !eid })

    const [{ loading: compLoading }, completeEntry] = usePet('completeEntry', { id: entry?._id }, { notify: true, callback: (_, notif, ops) => {
        notif('Changes have been saved', ops('success'))
        close()
    }, manual: true, load: { msg: 'Saving changes...' } })

    const [, fillNewEntry] = usePet('fillNewEntry', { 
        id,
        item: item?._id,
        entry: entry?._id,
        value: notes
    }, { notify: false, callback: ({ data }) => setEntry(data), manual: !eid })

    const onBlur = () => null

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ completeEntry } disabled={ compLoading } className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">{ entry?.filled ? 'Update' : 'Complete' }</button>
                    <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="40%">
            <p className="font-extrabold text-3xl mb-0">Take Notes</p>
            <p className="text-gray-500 text-xs italic">Write anything that would be necessary for future reference</p>
            {
                item.fields.map((fld, i) => 
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-1 leading-tight focus:outline-none focus:bg-white"
                        id="grid-notes"
                        rows="5"
                        name="notes"
                        value={ notes[i] }
                        onChange={ e => {
                            let nts = [...notes]
                            nts[i].name = fld.name
                            nts[i].value = e.target.value
                            setNotes(nts) 
                        } }
                        onBlur={ fillNewEntry }
                        placeholder="Notes..." />
                )
            }
        </Drawer>
    )
}

export default Notes